import React from "react"
import styled from "styled-components"
import { gsap } from "gsap/all"

import { COLORS } from "../../../theme/styles/globals"

export default class PageAnimation extends React.Component {

  animate() {

    const w = window.innerWidth

    gsap.set(".animated-block", { width:0 })
    gsap.to(".animated-block-1", { duration: 1, width:w, ease: "sine.easeOut" })
    gsap.to(".animated-block-2", { duration: 1, width:w, ease: "sine.easeOut", delay: .1 })
    gsap.to(".animated-block-3", { duration: 1, width:w, ease: "sine.easeOut", delay: .2 })
    gsap.to(".animated-block-4", { duration: 1, width:w, ease: "sine.easeOut", delay: .3 })
    gsap.to(".animated-block-5", { duration: 1, width:w, ease: "sine.easeOut", delay: .4 })
    
    gsap.to(".animated-block-1", { duration: 1, width:0, ease: "sine.easeOut", delay: 1.6 })
    gsap.to(".animated-block-2", { duration: 1, width:0, ease: "sine.easeOut", delay: 1.7 })
    gsap.to(".animated-block-3", { duration: 1, width:0, ease: "sine.easeOut", delay: 1.8 })
    gsap.to(".animated-block-4", { duration: 1, width:0, ease: "sine.easeOut", delay: 1.9 })
    gsap.to(".animated-block-5", { duration: 1, width:0, ease: "sine.easeOut", delay: 2 })
  
  }

  render() {
    return (
      <Container>
        <AnimatedBlockList>
          <BlockListItem position="left" className="animated-block animated-block-1" style={{ top:0 }} />
          <BlockListItem position="right" className="animated-block animated-block-2" style={{ top:'20vh' }} />
          <BlockListItem position="left" className="animated-block animated-block-3" style={{ top:'40vh' }} />
          <BlockListItem position="right" className="animated-block animated-block-4" style={{ top:'60vh' }} />
          <BlockListItem position="left" className="animated-block animated-block-5" style={{ top:'80vh' }} />
        </AnimatedBlockList>
      </Container>
    )
  }

}

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  pointer-events:none;
  z-index: 9999;
`

const AnimatedBlockList = styled.div`
  width: 100%;
  height: 100vh;
  display:flex;
  flex-direction:column;
  position:relative;
`

const BlockListItem = styled.div`
  background:${COLORS.DARK_GREY_2};
  width:0%;
  height:20vh;
  ${props => (props.position === `left` ? `left:0px;` : `right:0px;`)}
  position: absolute;
`

